/* CELLA — traduce los textos que kb.js escribe en español cuando la tienda está en otro idioma.
   Solo se carga fuera del español (ver sections/kb-cart-drawer.liquid). No cambia ninguna lógica del carrito. */
(function () {
  'use strict';
  if (window.__kbI18nUi) return;
  window.__kbI18nUi = true;
  var el = document.getElementById('kb-ui-i18n');
  if (!el) return;
  var T;
  try { T = JSON.parse(el.textContent); } catch (e) { return; }
  var root = T.root && T.root !== '/' ? T.root : '';
  var fixText = function (node) {
    var t = node.textContent;
    if (Object.prototype.hasOwnProperty.call(T.map, t) && T.map[t] && T.map[t] !== t) node.textContent = T.map[t];
  };
  var fix = function () {
    document.querySelectorAll('[data-add-label]').forEach(fixText);
    var toast = document.querySelector('.kb-toast');
    if (toast) fixText(toast);
    document.querySelectorAll('[data-cart-count]').forEach(function (c) {
      var a = c.closest('a'); if (!a) return;
      var m = (a.getAttribute('aria-label') || '').match(/^Cesta, (\d+) artículos$/);
      if (m) a.setAttribute('aria-label', T.cart.replace('{n}', m[1]));
    });
    var sr = document.querySelector('[data-search-results]');
    if (sr) {
      sr.querySelectorAll('p.kb-muted').forEach(function (p) {
        var m = p.textContent.match(/^Sin coincidencias para «(.*)»\.$/);
        if (m) p.textContent = T.none.replace('{q}', m[1]);
      });
      sr.querySelectorAll('a.kb-link').forEach(function (a) {
        if (a.textContent === 'Ver todos los resultados →') a.textContent = T.all;
        var h = a.getAttribute('href') || '';
        if (root && h.indexOf('/search') === 0) a.setAttribute('href', root + h);
      });
    }
  };
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; fix(); }, 0);
  }).observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['aria-label'] });
  fix();
})();
